// extracted by mini-css-extract-plugin
export default {"Save":"Save_Save__jryEe","selected":"Save_selected__H6Nxo"};